import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-grid-system'
import { ReservationFormProps } from './ReservationForm.props'
import {
  ReservationFormContainer,
  ReservationFormRow,
  ReservationFormFieldset,
  ReservationFormLegend,
  ReservationFormInput,
  ReservationFormTextArea,
  ReservationFormGroup,
  ReservationSpinnerContainer,
  ReservationNameContainer,
  ReservationPaymentStatusContainer,
  ReservationButtonsContainer,
  NoPaymentsMsg,
} from './ReservationForm.styled'

import Divider from 'components/Divider'
import { Text } from 'components/Text'
import CheckBox from 'components/CheckBox/CheckBox'
import RadioButton from 'components/RadioButton/RadioButton'
import Button from 'components/Button/Button'
import moment from 'moment'
// import CardForm from 'components/CardForm/CardForm'
import { useAppDispatch, useAppState } from 'store'
import Select from 'components/Select'
import { clientActions } from 'store/slices/clients/clients.slice'
import { SelectTypes } from 'components/Select/Select.props'
import { concat, uniqBy, find, pull } from 'lodash'
import {
  CreateTransaction,
  TransactionPayment,
  TransactionUser,
} from 'models/transaction.model'
import toast from 'cogo-toast'
import Spinner from 'components/Spinner'
import { appointmentActions } from 'store/slices/appointments/appointments.slice'
import { Input } from 'components/Input'
import { transactionActions } from 'store/slices/transactions/transactions.slice'
import PaymentSection from './PaymentSection'
import PaymentPill from 'components/PaymentPill'
import { useHistory } from 'react-router'
import ReservationModalDelete from './components/ReservationModalDelete.section'
import { Client } from 'models/client.model'
import { PENNIES } from 'utils/rate'
import { useAmplitude } from 'hooks/useAmplitude'
import { AMPLITUDE_EVENTS } from 'amplitude/events'
import { InvoicesAppointments } from 'services/appointment'

type PaymentMethods =
  | 'none'
  | 'cash'
  | 'account_balance'
  | 'saved_credit_card'
  | 'terminal'
  | 'check'

function ReservationForm({
  slotInfo,
  locationId,
  onClose,
  onDelete,
  type,
  appointmentId,
  currentEvent,
  selectedDate,
}: ReservationFormProps) {
  const { push } = useHistory()
  const dispatch = useAppDispatch()
  const {
    courts,
    categories,
    location,
    loadingAppointment,
    currentAppointment,
  } = useAppState(state => state.appointments)
  const { players, loading } = useAppState(state => state.clients)
  const { createLoading, invoices } = useAppState(state => state.transaction)
  const [payment, setPayment] = useState<PaymentMethods>('none')
  const [date, setDate] = useState<string>('')
  const [endDate, setEndDate] = useState<string>('')
  const [courtSelected, setCourtSelected] = useState<number[]>([])
  const [startHour, setStartHour] = useState<string>('')
  const [endHour, setEndHour] = useState<string>('')
  const [playersName, setPlayersName] = useState<SelectTypes[]>([])
  const [playersEmail, setPlayersEmail] = useState<SelectTypes[]>([])
  const [price, setPrice] = useState<number>(0)
  const [selectedPlayerName, setSelectedPlayerName] = useState<
    SelectTypes[] | undefined
  >(undefined)
  const [selectedPlayerEmail, setSelectedPlayerEmail] = useState<
    SelectTypes[] | undefined
  >(undefined)
  const [recurring, setRecurring] = useState<boolean>(false)
  const [notes, setNotes] = useState<string>('')
  const [categoryId, setCategoryId] = useState<number | null>(null)
  const [isDisabled, setIsDisabled] = useState<boolean>(false)
  const [isAppointment, setIsAppointment] = useState<boolean>(false)
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
  const [paymentStatus, setPaymentStatus] = useState<
    'paid' | 'unpaid' | 'partial'
  >()
  const [showPaymentMethod, setShowPaymentMethod] = useState<boolean>(true)
  const [appointmentInvoices, setAppointmentInvoices] = useState<InvoicesAppointments[]>([])
  const [programName, setProgramName] = useState<string>('')
  const { logEvent } = useAmplitude()

  useEffect(() => {
    if (locationId) {
      dispatch(appointmentActions.getAppointmentCategories(locationId))
      if (type === 'appointment' && appointmentId) {
        setIsAppointment(true)
        dispatch(
          appointmentActions.getSingleAppointment({ locationId, appointmentId })
        )
      }
    }
  }, [])

  useEffect(() => {
    if (type === 'reservation') {
      return setShowPaymentMethod(true)
    }
    if (type === 'appointment' && paymentStatus !== 'paid') {
      return setShowPaymentMethod(true)
    }
    setShowPaymentMethod(false)
  }, [type, paymentStatus])

  useEffect(() => {
    if (slotInfo && type === 'reservation') {
      const { start, slots } = slotInfo
      const newDate = moment(start).format('YYYY-MM-DD')
      const startDate = moment(start).format('HH:mm')
      const endTime = moment(slots[slots.length - 1]).format('HH:mm')
      setStartHour(startDate)
      setEndHour(endTime)
      setDate(newDate)
      setCourtSelected([parseInt(slotInfo.resourceId)])
    }
  }, [slotInfo])

  useEffect(() => {
    if (currentAppointment && type === 'appointment' && currentEvent) {

      const { start_time, end_time, date, notes, user, program, invoices } = currentAppointment
      const newDate = moment(date).format('YYYY-MM-DD')
      const startDate = moment(start_time).format('HH:mm')
      const endTime = moment(end_time).format('HH:mm')

      setStartHour(startDate)
      setEndHour(endTime)
      setDate(newDate)
      setCourtSelected(currentEvent.courts ? currentEvent.courts : [])
      setNotes(notes);
      setAppointmentInvoices(invoices);

      // exist posibility to get appointment with not user
      // If there is no user, and it is a program,
      // I will put the name of the program.

      const selectedPlayerName: SelectTypes[] = []
      const selectedPlayerEmail: SelectTypes[] = []

      if (user) {
        const { email, name } = user
        name && selectedPlayerName.push({ label: name, value: name })
        email &&
          !email.includes('@temp.com') &&
          !email.includes('@acespace.tennis') &&
          selectedPlayerEmail.push({ label: email, value: email })
      } else if (program && program.id) {
        selectedPlayerName.push({ label: program.name, value: program.name })
        setProgramName(program.name)
      }

      setSelectedPlayerEmail(selectedPlayerEmail)
      setSelectedPlayerName(selectedPlayerName)
    }
  }, [currentAppointment, currentEvent])

  useEffect(() => {
    if (isAppointment && invoices.length > 0) {
      const unpaidList = invoices.filter(invoice => invoice.paid === 'unpaid')
      const paidList = invoices.filter(invoice => invoice.paid === 'paid')
      if (unpaidList.length === invoices.length) {
        setPaymentStatus('unpaid')
        return
      }
      if (paidList.length === invoices.length) {
        setPaymentStatus('paid')
        return
      }
      if (unpaidList.length > 0 && unpaidList.length !== invoices.length) {
        setPaymentStatus('partial')
        return
      }
    }
  }, [isAppointment, invoices])

  useEffect(() => {
    if (players && players.length > 0) {
      const newPlayersName = players.map((player: Client) => {
        return { label: player.title, value: player.id.toString() }
      })
      const newPlayersEmail = players.map((player: Client) => {
        return { label: player.email, value: player.id.toString() }
      })
      setPlayersName(newPlayersName)
      setPlayersEmail(newPlayersEmail)
    }
  }, [players])

  useEffect(() => {
    if (selectedPlayerName && selectedPlayerName.length <= 1) {
      setIsDisabled(false)
    }
    if (selectedPlayerName && selectedPlayerName.length > 1) {
      setIsDisabled(true)
    }
  }, [selectedPlayerName])

  useEffect(() => {
    if (location && location.min_price) {
      setPrice(location.min_price)
    }
  }, [location])

  const handleCourtSelected = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    courtId: number
  ) => {
    e.preventDefault()
    const selected = [...courtSelected]
    if (courtSelected.includes(courtId)) {
      pull(selected, courtId)
      setCourtSelected(selected)
      return
    } else {
      selected.push(courtId)
      setCourtSelected(selected)
      return
    }
  }

  const handlePlayers = (text: string) => {
    if (text.length >= 3) {
      dispatch(
        clientActions.getClientPlayers({
          locationId: locationId ? locationId : '',
          page: 0,
          limit: 100,
          search_text: text,
        })
      )
      return
    }
  }

  const handleSelectedPlayer = (
    selected: SelectTypes[],
    type: 'name' | 'email'
  ) => {
    if (type === 'name') {
      setSelectedPlayerName(selected)
      const emails = handleDefaultPlayer(selected, 'email')
      setSelectedPlayerEmail(emails)
      return
    }
    if (type === 'email') {
      setSelectedPlayerEmail(selected)
      const players = handleDefaultPlayer(selected, 'name')
      setSelectedPlayerName(players)
      return
    }
  }

  const handleDefaultPlayer = (
    selected: SelectTypes[],
    type: 'name' | 'email'
  ): SelectTypes[] => {
    const newDefaultPlayers: SelectTypes[] = []
    if (players) {
      players.forEach(() => {
        selected.forEach(current => {
          if (!current.__isNew__) {
            const client = find(players, { id: parseInt(current.value) })
            if (client) {
              newDefaultPlayers.push({
                label: type === 'name' ? client.name : client.email,
                value: client?.id.toString(),
              })
            }
          }
        })
      })
    }
    const filterPlayers = uniqBy(newDefaultPlayers, 'value')
    if (selectedPlayerEmail && type === 'email') {
      const pastEmails = [...selectedPlayerEmail]
      const newElements = concat(pastEmails, filterPlayers)
      return uniqBy(newElements, 'value')
    }
    if (selectedPlayerName && type === 'name') {
      const pastPlayers = [...selectedPlayerName]
      const newElements = concat(pastPlayers, filterPlayers)
      return uniqBy(newElements, 'value')
    }
    return filterPlayers
  }

  const formatDate = (hour: string) => {
    const newStart = moment(
      date.replace(/-/g, '/') + ' ' + hour,
      'YYYY-MM-DD HH:mm'
    )
    return newStart.format('YYYY-MM-DD[T]HH:mm:ss')
  }

  const formatUsers = () => {
    if (selectedPlayerName && selectedPlayerName.length > 0) {
      const users: TransactionUser[] = selectedPlayerName.map(players => {
        const email = find(selectedPlayerEmail, { value: players.value })
        const numberFormatted = parseInt(players.value)
        return {
          id: Number.isNaN(numberFormatted) ? null : players.value,
          title: players.label,
          email: email ? email.label : '',
        }
      })
      return users
    }
  }

  const goToProfile = () => {
    if (currentAppointment) {
      push(
        `/locations/${locationId}/settings/clients/${currentAppointment.user_id}`
      )
    }
  }

  const formatPayments = (users: TransactionUser[]) => {
    const payments: TransactionPayment[] = users.map(user => {
      const newUser: TransactionPayment = {
        user_id: user.id ? user.id : '',
        user_email: user.email,
        invoice_required: true,
        payment_required: true,
        credit_card_processing_fee: null,
        amount: price * PENNIES,
        subtotal: price * PENNIES,
        discount: 0,
        description: 'Appointment payment',
        payment_method: {
          payment_required: false,
          payment_method_id: null,
          payment_type: payment,
        },
      }
      if (!newUser.user_email) {
        newUser.user_id = null
        newUser.user_name = selectedPlayerName
          ? selectedPlayerName[0].label
          : ''
      }
      return newUser
    })
    return payments
  }

  const handleSubmit = async () => {
    if (!selectedPlayerName || selectedPlayerName.length === 0) {
      toast.error('Player name is required', {
        position: 'top-right',
      })
      return
    }
    const newStartDate = formatDate(startHour)
    const newEndDate = formatDate(endHour)
    const users = formatUsers()
    const usersPayments = users && formatPayments(users)
    const body: CreateTransaction = {
      transaction_item: {
        date,
        notes,
        recurring,
        recurring_end_date: endDate,
        transaction_type: 'appointment',
        start_date: newStartDate,
        end_date: newEndDate,
        court_ids: courtSelected,
        reservation_category_id: categoryId ? categoryId : null,
      },
      users: users ? users : [],
      payments: usersPayments ? usersPayments : [],
    }

    if (locationId) {
      await dispatch(
        transactionActions.createTransaction({
          locationId,
          body,
        })
      )

      logEvent(AMPLITUDE_EVENTS.APPOINTMENT_MODAL_CREATE_EVENT, {
        location: locationId,
        appointment_date: date,
        appointment_time: startHour,
      })

      onClose(true)

      if (selectedDate) {
        await dispatch(
          appointmentActions.getAppointments({
            locationId: locationId.toString(),
            startDate: moment(selectedDate).format('yyyy-MM-DD'),
            endDate: moment(selectedDate).format('yyyy-MM-DD'),
          })
        )
      }
    }
  }

  const handleAppointment = async (param: boolean) => {
    if (param && locationId && appointmentId && notes) {
      await dispatch(
        appointmentActions.updateAppointment({
          locationId,
          appointmentId,
          notes,
          court_ids: courtSelected,
        })
      )
    }
    onClose(param)
  }

  const handleDeleteAppointment = async () => {
    if (locationId && appointmentId) {
      await dispatch(
        appointmentActions.deleteAppointment({
          locationId,
          appointmentId,
        })
      )
      if (onDelete) onDelete()
    }
  }

  return (
    <>
      {createLoading === 'loading' || loadingAppointment === 'loading' ? (
        <ReservationSpinnerContainer>
          <Spinner />
        </ReservationSpinnerContainer>
      ) : (
        <ReservationFormContainer>
          {type === 'appointment' && paymentStatus && (
            <ReservationPaymentStatusContainer>
              <PaymentPill type={paymentStatus} />
            </ReservationPaymentStatusContainer>
          )}
          <ReservationFormRow>
            <Col xs={12} sm={12} md={6} lg={6}>
              <ReservationNameContainer>
                <Select
                  required
                  autocomplete
                  isMulti
                  creatable
                  options={playersName}
                  label={
                    currentAppointment?.user_id || !programName
                      ? 'Player Name'
                      : 'Program Name'
                  }
                  placeholder="Player Name"
                  onInputChange={handlePlayers}
                  isLoading={loading === 'loading' ? true : false}
                  value={selectedPlayerName}
                  onChange={player =>
                    handleSelectedPlayer(player as SelectTypes[], 'name')
                  }
                  disabled={type === 'appointment' ? true : false}
                  openMenuOnFocus
                  autoFocus={type !== 'appointment' ? true : false}
                />
                {type === 'appointment' && currentAppointment?.user_id && (
                  <Button
                    style={{ marginLeft: 15 }}
                    size="small"
                    variant="primary"
                    text="Profile"
                    onClick={goToProfile}
                  />
                )}
              </ReservationNameContainer>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
              <Select
                autocomplete
                options={categories}
                label="Category"
                onChange={category => {
                  const selected = category as SelectTypes
                  setCategoryId(parseInt(selected ? selected.value : ''))
                }}
                disabled={type === 'appointment' ? true : false}
              />
            </Col>
          </ReservationFormRow>

          <ReservationFormRow>
            <Col xs={12} sm={12} md={6} lg={6}>
              <Select
                autocomplete
                isMulti
                creatable
                options={playersEmail}
                label="Email"
                placeholder="Player Email"
                onInputChange={handlePlayers}
                value={selectedPlayerEmail}
                isLoading={loading === 'loading' ? true : false}
                onChange={player =>
                  handleSelectedPlayer(player as SelectTypes[], 'email')
                }
                disabled={type === 'appointment' ? true : false}
              />
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
              <ReservationFormFieldset>
                <ReservationFormLegend>Date</ReservationFormLegend>
                <ReservationFormInput
                  type="date"
                  placeholder="01/01/2021"
                  style={{ fontFamily: 'Work Sans' }}
                  value={date}
                  disabled={type === 'appointment' ? true : false}
                  onChange={date => setDate(date.target.value)}
                />
              </ReservationFormFieldset>
            </Col>
          </ReservationFormRow>

          <ReservationFormRow style={{ marginBottom: 10 }}>
            <Col xs={12} sm={12} md={6} lg={6}>
              <ReservationFormFieldset>
                <ReservationFormLegend>Notes</ReservationFormLegend>
                <ReservationFormTextArea
                  rows={4}
                  placeholder="Notes"
                  style={{ fontFamily: 'Work Sans' }}
                  value={notes}
                  onChange={e => setNotes(e.target.value)}
                />
              </ReservationFormFieldset>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
              <ReservationFormRow style={{ marginTop: 0, marginBottom: 20 }}>
                <Col xs={12} sm={12} md={6} lg={6}>
                  <ReservationFormFieldset>
                    <ReservationFormLegend>Start Time</ReservationFormLegend>
                    <ReservationFormInput
                      type="time"
                      value={startHour}
                      style={{ fontFamily: 'Work Sans' }}
                      disabled={type === 'appointment' ? true : false}
                      onChange={e => setStartHour(e.target.value)}
                    />
                  </ReservationFormFieldset>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6}>
                  <ReservationFormFieldset>
                    <ReservationFormLegend>End Time</ReservationFormLegend>
                    <ReservationFormInput
                      type="time"
                      value={endHour}
                      style={{ fontFamily: 'Work Sans' }}
                      disabled={type === 'appointment' ? true : false}
                      onChange={e => setEndHour(e.target.value)}
                    />
                  </ReservationFormFieldset>
                </Col>
              </ReservationFormRow>
              <ReservationFormRow style={{ marginTop: 0 }}>
                <Col xs={12} sm={12} md={6} lg={6}>
                  <ReservationFormGroup>
                    <CheckBox
                      weight="500"
                      text="Appointment is Recurring"
                      checked={recurring}
                      onChange={() => setRecurring(!recurring)}
                      disabled={type === 'appointment' ? true : false}
                    />
                  </ReservationFormGroup>
                </Col>
                {recurring && (
                  <Col xs={12} sm={12} md={6} lg={6}>
                    <ReservationFormFieldset style={{ marginTop: -10 }}>
                      <ReservationFormLegend>End Date</ReservationFormLegend>
                      <ReservationFormInput
                        type="date"
                        placeholder="01/01/2021"
                        style={{ fontFamily: 'Work Sans' }}
                        value={endDate}
                        disabled={type === 'appointment' ? true : false}
                        onChange={date => setEndDate(date.target.value)}
                      />
                    </ReservationFormFieldset>
                  </Col>
                )}
              </ReservationFormRow>
            </Col>
          </ReservationFormRow>

          {courts && courts.length > 0 && (
            <ReservationFormRow style={{ marginTop: 0 }}>
              <Col xs={12} sm={12} md={6} lg={6}>
                <Text text="Select Courts" weight="600" />
                {courts.map(court => (
                  <ReservationFormGroup
                    onClick={e => handleCourtSelected(e, parseInt(court.id))}
                    key={`${court.id}-${court.title}`}>
                    <CheckBox
                      weight="500"
                      text={court.title}
                      value={court.id}
                      checked={courtSelected.includes(parseInt(court.id))}
                    />
                  </ReservationFormGroup>
                ))}
              </Col>
            </ReservationFormRow>
          )}

          {isAppointment && (
            <>
              <ReservationButtonsContainer>
                <Button
                  size="medium"
                  variant="secondary"
                  text="Discard Appointment"
                  onClick={() => {
                    setShowDeleteModal(true)
                  }}
                />
                <Button
                  style={{ marginLeft: 15 }}
                  size="medium"
                  variant="primary"
                  text="Dismiss changes"
                  onClick={() => {
                    handleAppointment(false)
                  }}
                />
                <Button
                  style={{ marginLeft: 15 }}
                  size="medium"
                  variant="primary"
                  text="Save & Close"
                  onClick={() => {
                    handleAppointment(true)
                  }}
                />
              </ReservationButtonsContainer>

              {showDeleteModal && (
                <ReservationModalDelete
                  onConfirm={() => {
                    handleDeleteAppointment()
                  }}
                  onClose={() => {
                    setShowDeleteModal(false)
                  }}></ReservationModalDelete>
              )}
            </>
          )}

          <Divider />
          {type === 'appointment' && (
            <>
              <ReservationFormRow style={{ margin: '25px 0' }}>
                <Col xs={12} sm={12} md={8} lg={8}>
                  <Text
                    preset="h4"
                    text="Payment History"
                    weight="600"
                    color="primary"
                  />
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                {appointmentInvoices.length ? (appointmentInvoices.map(appInvoice => <PaymentSection key={appInvoice.id} invoice={appInvoice} />)) :  (<NoPaymentsMsg>No payments yet</NoPaymentsMsg>)}
                </Col>
              </ReservationFormRow>
              <Divider />
            </>
          )}

          {showPaymentMethod && (
            <ReservationFormRow style={{ margin: '25px 0' }}>
              <Col xs={12} sm={12} md={4} lg={4}>
                <Row>
                  <Col xs={12} sm={12} md={8} lg={8}>
                    <Input
                      label="Price"
                      currencyMask
                      value={price}
                      onTextChange={price => setPrice(+price)}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={12} md={7} lg={7}>
                <Text text="Payment Method" weight="600" />
                <ReservationFormGroup>
                  <RadioButton
                    key="radio-payment-1"
                    weight="500"
                    name="payment"
                    text={['None']}
                    value="none"
                    onChange={value =>
                      value && setPayment(value as PaymentMethods)
                    }
                    checked={payment === 'none'}
                  />
                </ReservationFormGroup>
                <ReservationFormGroup>
                  <RadioButton
                    key="radio-payment-2"
                    weight="500"
                    name="payment"
                    text={['Cash']}
                    value="cash"
                    onChange={value =>
                      value && setPayment(value as PaymentMethods)
                    }
                    checked={payment === 'cash'}
                  />
                </ReservationFormGroup>
                <ReservationFormGroup>
                  <RadioButton
                    key="radio-payment-3"
                    weight="500"
                    name="payment"
                    text={['Account Balance']}
                    value="account_balance"
                    onChange={value =>
                      value && setPayment(value as PaymentMethods)
                    }
                    checked={payment === 'account_balance'}
                  />
                  {console.log(payment)}
                </ReservationFormGroup>
                <ReservationFormGroup>
                  <RadioButton
                    key="radio-payment-4"
                    weight="500"
                    name="payment"
                    text={['Terminal']}
                    value="terminal"
                    onChange={value =>
                      value && setPayment(value as PaymentMethods)
                    }
                    checked={payment === 'terminal'}
                    disabled={isDisabled}
                  />
                </ReservationFormGroup>
                <ReservationFormGroup>
                  <RadioButton
                    key="radio-payment-5"
                    weight="500"
                    name="payment"
                    text={['Saved Credit Card']}
                    value="saved_credit_card"
                    onChange={value =>
                      value && setPayment(value as PaymentMethods)
                    }
                    checked={payment === 'saved_credit_card'}
                    disabled={isDisabled}
                  />
                </ReservationFormGroup>

                {/* {payment === 'Credit Card' && <CardForm />} */}

                {!isAppointment && (
                  <Button
                    style={{ marginLeft: 25, marginTop: 15 }}
                    size="small"
                    variant="secondary"
                    text="Submit"
                    onClick={handleSubmit}
                  />
                )}
              </Col>
            </ReservationFormRow>
          )}
        </ReservationFormContainer>
      )}
    </>
  )
}

export default ReservationForm
